import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import Checkbox from './Checkbox'
import StatsBaseWindow from './StatsBaseWindow'

class DonateWindow extends Component {
    constructor(props) {
        super(props);

        this.position = {top: 100, left: 100}
        this.width = 462;
        this.height = 278;

        this.position.left = window.innerWidth / 2 - this.width / 2;
        this.position.top = window.innerHeight / 2 - 200;
    }

    render() {
        const { toggle_donate_window_visibility } = this.props.StatisticActions;
        
        return (<PopupWindow header="Пожертвование" draggable={false} show_cut_down={false} width={this.width} top={this.position.top}  left={this.position.left} onClose={() => toggle_donate_window_visibility()}>
                    <iframe src="https://money.yandex.ru/quickpay/shop-widget?writer=seller&targets=%D0%9D%D0%B0%20%D1%80%D0%B0%D0%B7%D0%B2%D0%B8%D1%82%D0%B8%D0%B5%20%D0%9F%D0%95%D0%A4%D0%9B%20%D0%A2%D0%92&targets-hint=&default-sum=500&button-text=14&payment-type-choice=on&mobile-payment-type-choice=on&comment=on&hint=%D0%BD%D0%B8%D0%BA%20%D0%BD%D0%B0%20%D0%9F%D0%95%D0%A4%D0%9B%2C%20%D0%B6%D0%B5%D0%BB%D0%B0%D0%B5%D0%BC%D0%B0%D1%8F%20%D1%84%D0%B8%D1%87%D0%B0%20%D0%B8%20%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%B5&successURL=http%3A%2F%2Fpefl.ru&quickpay=shop&account=410015421702058" width="450" height="290" frameBorder="0" allowTransparency="true" scrolling="no"></iframe>
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DonateWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/DonateWindow.js
 **/